// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-37cd40e9] .ag-root-wrapper{overflow:visible}", ""]);
// Exports
module.exports = exports;
